let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8lXXu")).then(() => parcelRequire('cTX1C'));